import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/home'
// import ITJobMarket from '@/views/ITJobMarket'
// import ITCommunity from '@/views/ITCommunity'
// import ITFreelance from '@/views/ITFreelance'
// import ITFreelanceNew from '@/views/ITFreelanceNew'
// import ITzhaohuo from '@/views/ITzhaohuo'
import store from '@/store'

// 导入我的信息组件
import MyInfo from '@/components/UserInfo/MyInfo'

Vue.use(Router)

export const constantRouterMap = [
  // 根路径直接访问ITMarket
  {
    path: '/',
    component: () => import('@/views/ITMarket'),
  },
  // HomeIndex作为所有其他路由的布局组件
  {
    path: '/',
    component: HomeIndex, // 直接使用导入的组件，不使用懒加载
    children: [
      {path: '/about', component: () => import('@/views/about')},
      {path: '/life', component: () => import('@/views/life')},
      {path: '/list', component: () => import('@/views/list')},
      {path: '/sort', component: () => import('@/views/sort')},
      {path: '/subject', component: () => import('@/views/special')},
      // { path: '/subject2', component: () => import('@/views/special') },
      {
        path: '/subject/:subjectUid',
        component: () => import('@/views/specialDetail')
      },
      {path: '/time', component: () => import('@/views/time')},
      {path: '/rank', component: () => import('@/views/rank')},
      {
        path: '/info/:blogOid',
        component: () => import('@/views/info')
      },
      {path: '/messageBoard', component: () => import('@/views/messageBoard')},
      {path: '/experience', component: () => import('@/views/experience')},
      {
        path: '/experienceInfo/:experienceOid',
        component: () => import('@/views/experienceInfo')
      },
      {path: '/question', component: () => import('@/views/question')},
      {
        path: '/qInfo/:questionOid',
        component: () => import('@/views/questionInfo')
      },
      {path: '/code', component: () => import('@/views/code')},
      {
        path: '/cInfo/:problemOid',
        component: () => import('@/views/codeInfo')
      },
      {path: '/userCenter', component: () => import('@/views/userCenter')},
      {path: '/user-center', component: () => import('@/views/PersonalCenter')},
      {path: '/notice', component: () => import('@/views/notice')},
      {path: '/moment', component: () => import('@/views/moment')},
      {path: '/chat', component: () => import('@/views/chatRoom')},
      {path: '/media', component: () => import('@/views/mediaInfoList')},
      {path: '/video/:videoId?', component: () => import('@/views/mediaVideo')},
      {path: '/hot', component: () => import('@/views/hot')},
      {path: '/resource', component: () => import('@/views/resource')},
      {path: '/resource/:resourceUid', component: () => import('@/views/resourceDetail')},
      {path: '/medal/:userUid', component: () => import('@/views/medal')},
      {path: '/sponsor', component: () => import('@/views/sponsor')},
      {path: '/version', component: () => import('@/views/version')},
      {path: '/lucky', component: () => import('@/views/lucky')},
      {path: '/vip', component: () => import('@/views/vip')},
      {path: '/mall', component: () => import('@/views/mall')},
      {path: '/mall/:productUid', component: () => import('@/views/mallDetail')},
       // {path: '/sharefile/:shareBatchNum',component: () => import('@/views/shareFile')},
      // 2024-09-30 新增(zxg)
      {path: '/utilities', component: () => import('@/views/utilities')},
      {path: '/toolsDoc', component: () => import('@/views/toolsDoc')},
      {path: '/blobList', component: () => import('@/views/blobList')},
      {path: '/courseVideo', component: () => import('@/views/courseVideo')},
      {path: '/courseDetail', component: () => import('@/views/courseDetail')},
      {path: '/engineerList', component: () => import('@/views/engineerList')},
      {path: '/engineerDetail/:uid', component: () => import('@/views/engineerDetail')},
      {
        path: 'task-detail/:id',
        name: 'TaskDetail',
        component: () => import('@/components/CreateCenter/TaskDetail.vue'),
        meta: { title: '任务详情' }
      },
      {
        path: '/cooperateJob/detail/:uid',
        name: 'CooperateJobDetail',
        component: () => import('@/components/CreateCenter/cooperateJob.vue'),
        meta: { title: '合作任务详情' }
      },
      {
        path: '/cooperateJob/detail',
        name: 'CooperateJobDetailState',
        component: () => import('@/components/CreateCenter/cooperateJob.vue'),
        meta: { title: '合作任务详情' }
      },
      {
        path: 'workService',
        name: 'workService',
        component: () => import('@/components/workService/index')
      },
          // 任务大厅路由地址 新增（zxg）  '@/components/workService/index'
      {path: '/workService', component: () => import('@/components/workService/index')},
      // {path: '/workDetail', component: () => import('@/components/workService/detail')},
      {path: '/workDetail/:jobUid', component: () => import('@/components/workService/detail')},
      {path: '/cooperateJobList', component: () => import('@/views/cooperateJobList')},
      {
        path: '/share/:shareBatchNum',
        name: 'ShareFile',
        component: () => import('@/views/shareFileView'),
        meta: { title: '文件分享' }
      },
      // {
      //   path: 'community',
      //   name: 'ITCommunity',
      //   component: (HomeIndex) => ITCommunity,
      //   meta: {
      //     title: 'IT技术社区 - 分享技术，连接价值'
      //   }
      // },
      // 工程师自荐相关页面
      {path: '/engineerSelfRecommList', component: () => import('@/components/EngineerSelfRecomm/EngineerSelfRecommList')},
      {path: '/engineerSelfRecommDetail', component: () => import('@/components/EngineerSelfRecomm/EngineerSelfRecommDetail')},
      // 添加我的信息路由
      {
        path: '/myinfo',
        name: 'MyInfo',
        component: MyInfo,
        meta: {
          title: '我的信息',
          requireAuth: true
        }
      },
     
     
    ]
  },
  // 创作中心路由地址 新增（zxg）  '@/components/CreateCenter/question'
  {
    path: '/createdCenter',
    redirect:'/createdCenter/index',
    component: () => import('@/views/createCenter'),
    children: [
      {path: 'index', component: () => import('@/components/CreateCenter/index')},
      {path: 'userInfo', component: () => import('@/components/CreateCenter/userInfo')},
      {path: 'moneyAccount', component: () => import('@/components/CreateCenter/moneyAccount')},
      //创作
      {path: 'createBlog', component: () => import('@/components/CreateCenter/blog')},
      {path: 'createDoc', component: () => import('@/components/CreateCenter/doc')},
      {path: 'createTool', component: () => import('@/components/CreateCenter/tool')},
      {path: 'createCourse', component: () => import('@/components/CreateCenter/course')},
      //我的任务
      {path: 'createTask', component: () => import('@/components/CreateCenter/createTask')},
      {path: 'myTask', component: () => import('@/components/CreateCenter/myTask')},
      // 添加合作任务路由
      {path: 'myCooperateJob', component: () => import('@/components/CreateCenter/myCooperateJob')},
      //我的经验
      {path: 'myExper', component: () => import('@/components/CreateCenter/myExper')},
      {
        path: 'myDoc',
        name: 'myDoc',
        component: () => import('@/components/CreateCenter/myDoc')
      },
      {
        path: 'myTool',
        name: 'myTool',
        component: () => import('@/components/CreateCenter/myTool')
      },
      {
        path: 'myCourse',
        name: 'myCourse',
        component: () => import('@/components/CreateCenter/myCourse')
      },
      {
        path: 'interactionManagement',
        name: 'InteractionManagement',
        component: () => import('@/components/CreateCenter/interactionManagement'),
        meta: { title: '互动管理' }
      },
      {
        path: 'fanFollowManagement',
        name: 'FanFollowManagement',
        component: () => import('@/components/CreateCenter/fanFollowManagement'),
        meta: {
          title: '粉丝关注管理'
        }
      },
      {
        path: 'collectionManagement',
        name: 'CollectionManagement',
        component: () => import('@/components/CreateCenter/collectionManagement'),
        meta: {
          title: '收藏管理'
        }
      },
      {
        path: 'systemNotice',
        name: 'SystemNotice',
        component: () => import('@/components/CreateCenter/systemNotice'),
        meta: {
          title: '系统通知'
        }
      },
      // 工程师自荐相关路由
      {
        path: 'engineerSelfRecomm',
        name: 'EngineerSelfRecomm',
        component: () => import('@/components/CreateCenter/engineerSelfRecomm'),
        meta: {
          title: '工程师自荐'
        }
      },
      {
        path: 'myEngineerSelfRecomm',
        name: 'MyEngineerSelfRecomm',
        component: () => import('@/components/CreateCenter/myEngineerSelfRecomm'),
        meta: {
          title: '我的自荐信息'
        }
      },
      {
        path: 'myToolBox',
        name: 'myToolBox',
        component: () => import('@/components/toolBox/toolBox')
      }
    ]
  },

  // 协议页面路由
 {
  path: '/user-agreement',
  name: 'UserAgreement',
  component: () => import('@/components/agreement/UserAgreement'),
  meta: {
    title: 'IT找活网用户服务条款'
  }
},
{
  path: '/privacy-policy',
  name: 'PrivacyPolicy',
  component: () => import('@/components/agreement/PrivacyPolicy'),
  meta: {
    title: 'IT找活网隐私政策'
  }
},
{
  path: '/platform-disclaimer',
  name: 'PlatformDisclaimer',
  component: () => import('@/components/agreement/PlatformDisclaimer'),
  meta: {
    title: 'IT找活网网络平台信息发布免责协议'
  }
},
{
  path: '/engineer-disclaimer',
  name: 'EngineerDisclaimer',
  component: () => import('@/components/agreement/EngineerDisclaimer'),
  meta: {
    title: 'IT找活网工程师注册免责协议'
  }
},


  // 信息认证路由地址
  {
    path: '/authentication',
    name: 'Authentication',
    component: () => import('@/components/CreateCenter/authIndex'),
    meta: {
      title: '身份认证',
      requireAuth: true
    }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/components/CreateCenter/auth'),
    meta: {
      title: '认证申请',
      requireAuth: true
    }
  },
  {
    path: '/auth-condition',
    name: 'AuthCondition', 
    component: () => import('@/components/CreateCenter/condition'),
    meta: {
      title: '认证条件',
      requireAuth: true
    }
  },
  {
    path: '/user-info',
    name: 'UserInfo',
    component: () => import('@/components/CreateCenter/userInfo'),
    meta: {
      title: '用户信息',
      requireAuth: true
    }
  },
  
  // {
  //   path: '/online-office',
  //   name: 'OnlineOffice',
  //   component: () => import('@/views/OnlineOffice'),
  //   meta: {
  //     title: '在线办公室',
  //     requireAuth: true  // 需要登录才能访问
  //   }
  // },

  // {path: '/it-freelance-new', component: (ITFreelanceNew),
  //   meta: {
  //     title: 'IT副业网 - 技术人员的副业平台'
  //   }
  // },

  // {path: '/it-zhaohuo', component: (ITzhaohuo),
  //   meta: {
  //     title: 'IT找活网 - 技术人员的接单平台'
  //   }
  // },

  // {
  //   path: '/it-freelance',name: 'ITFreelance',component: ITFreelance,
  //   meta: {
  //     title: 'IT副业网 - 技术人员的副业平台'
  //   }
  // },
  

  // { path: '/it-market-new', name: 'ITJobMarketNew', component: () => import('@/views/ITMarket'),
  //   meta: {
  //     title: 'IT找活网 - 技术人员的接单平台'
  //   }
  // },

  {path: '/404', component: () => import('@/views/404')},
  {path: '/403', component: () => import('@/views/403')},
  {path: '/500', component: () => import('@/views/500')},
  {path: '/502', component: () => import('@/views/502')},
  {path: '/success', component: () => import('@/views/success')},
  {path: '/error', component: () => import('@/views/error')},
  
  {path: '*', component: () => import('@/views/404')},
  
]

const router = new Router({
  mode: 'history',
  routes: constantRouterMap
})

// 定义需要登录的路由
const requireAuth = [
  '/user/center',
  '/user/tasks',
  '/user/messages',
  '/task/publish',
  '/article/write',
  '/tools'
]

// router.beforeEach(async (to, from, next) => {
//   // 检查是否需要登录
//   const needAuth = requireAuth.some(path => to.path.startsWith(path))
  
//   if (needAuth) {
//     // 检查登录状态
//     const isLoggedIn = store.getters['user/isLoggedIn']
//     const token = store.getters['user/token']
    
//     if (!isLoggedIn || !token) {
//       // 保存目标路由，登录后跳转
//       store.commit('setRedirectPath', to.fullPath)
      
//       // 显示提示
//       Vue.prototype.$notify({
//         title: '需要登录',
//         message: '请先登录后再访问该页面',
//         type: 'warning',
//         duration: 2000
//       })
      
//       // 不再直接跳转到登录页，而是打开登录框
//       store.commit('setShowLogin', true)
//       next(false) // 中断当前导航
//       return
//     }
//   }

//   // 检查是否有重定向路径
//   const redirectPath = store.state.redirectPath
//   if (redirectPath && to.path === '/') {
//     // 清除重定向路径
//     store.commit('setRedirectPath', '')
//     // 直接重定向到目标路径
//     next(redirectPath)
//     return
//   }
  
//   next()
// })

// router.beforeEach((to, from, next) => {
//   console.log("获取路径", to, from)
//   console.log("------------")
//   console.log(store.state.app.webNavbarList)
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js